import React, {Component} from 'react'
import {browserHistory} from 'react-router'
import SearchComponent from './SearchComponent'
import {Actions} from 'jumpstate'

import './Layout/SearchBox.css'

class SearchBox extends Component {
  render () {
    const searchInPath = (term) => this.context.router.location.pathname.includes('breeder') ? `breeder-result?q=${term}` : `/result?q=${term}`
    return (
      <SearchComponent onResult={(term) => {
        Actions.searchHorse({term: term, page: 1}).then((res) => {
          browserHistory.push(searchInPath(term))
        })
      }} />
    )
  }
}

SearchBox.contextTypes = {
  router: React.PropTypes.object
}

export default SearchBox



// WEBPACK FOOTER //
// ./src/components/Common/SearchBox/SearchBox.js